export default function Grid() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_7012_4108" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
                <path d="M40 0H0V40H40V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_7012_4108)">
                <path
                    d="M13.3337 17.5L6.66699 10.8333H33.3337L27.5003 17.5M13.3337 17.5H27.5003M13.3337 17.5L16.667 6.66667H24.167L27.5003 17.5M13.3337 17.5L12.1432 21.6667M27.5003 17.5L28.6908 21.6667M8.33366 35L9.32756 31.5213M32.5003 35L31.5064 31.5213M12.1432 21.6667L31.5064 31.5213M12.1432 21.6667L9.32756 31.5213M31.5064 31.5213L28.6908 21.6667M28.6908 21.6667L9.32756 31.5213"
                    stroke="#69BAF2"
                    strokeWidth="2.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
